import { Button, Cell, Group, Header, Paragraph, Title } from "@vkontakte/vkui";
import { Page } from "../components/Page";

const pages = {
  "/legal/privacy": {
    title: "Политика конфиденциальности",
    sections: [
      ["Какие данные обрабатываются", "VK ID, ФИО, аватар, данные членской карты, сведения о партнёрских скидках и пользовательские настройки приватности."],
      ["Зачем это нужно", "Для авторизации в VK Mini Apps, проверки членства, предоставления скидок, ведения лидерборда и аудита действий."],
      ["Доступ партнёров", "Партнёр получает ФИО, номер карты, уровень и срок действия только после ввода конкретного номера карты. Лишние персональные данные партнёрам не раскрываются."]
    ]
  },
  "/legal/terms": {
    title: "Пользовательское соглашение",
    sections: [
      ["Назначение сервиса", "Приложение является цифровой членской картой, каталогом партнёров и инструментом фиксации предоставленных скидок."],
      ["Ограничения", "Скидки действуют по правилам конкретного партнёра и только при активном членстве. Администрация может блокировать карту при нарушении правил."],
      ["Платные функции", "Платежи и продвижение зарезервированы для следующих версий MVP и сейчас не списывают деньги."]
    ]
  },
  "/legal/consent": {
    title: "Согласия",
    sections: [
      ["Персональные данные", "Пользователь даёт согласие на обработку данных, необходимых для работы членской карты и партнёрских скидок."],
      ["Показ ФИО партнёру", "Пользователь соглашается, что партнёр увидит ФИО при проверке конкретного номера карты для сверки с документом."],
      ["Лидерборд", "Отображение в таблице рекордсменов управляется отдельно в профиле."]
    ]
  }
};

export function LegalPage({ path, navigate }: { path: string; navigate: (path: string) => void }) {
  const page = pages[path as keyof typeof pages] || pages["/legal/privacy"];

  return (
    <Page title={page.title}>
      <Group header={<Header>{page.title}</Header>}>
        {page.sections.map(([title, text]) => (
          <Cell key={title} multiline>
            <Title level="3">{title}</Title>
            <Paragraph>{text}</Paragraph>
          </Cell>
        ))}
      </Group>
      <Button mode="secondary" onClick={() => navigate("/")}>
        На главную
      </Button>
    </Page>
  );
}
